export const CONSTANTS_GENERATION__slider_step = {
  IMAGE_SIZE_DEFAULT: 64,
  IMAGE_SIZE_VALUES: [8, 16, 32, 64],

  CONTROL_NET_VALUES: [1, 2, 5, 10, 25, 50],
  CONTROL_NET_DEFAULT: 25,

  GUIDANCE_SCALE_VALUES: [0.5, 1, 2, 3, 5, 10, 25],
  GUIDANCE_SCALE_DEFAULT: 3,

  GUIDANCE_RESCALE_VALUES: [0.1, 0.25, 0.5],
  GUIDANCE_RESCALE_DEFAULT: 0.25,

  INFERENCE_STEPS_VALUES: [1, 2, 5, 10, 25, 50],
  INFERENCE_STEPS_DEFAULT: 2,

  IP_ADAPTER_VALUES: [1, 2, 5, 10, 25, 50],
  IP_ADAPTER_DEFAULT: 25,

  WEIGHT_VALUES: [0.1, 0.25, 0.5, 1],
  WEIGHT_DEFAULT: 0.25,

  STEPS_VALUES: [0.01, 0.02, 0.05, 0.1, 0.25, 0.5],
  STEPS_DEFAULT: 0.25,

  TOKEN_WEIGHT_DEFAULT: 0.25,
  TOKEN_WEIGHT_VALUES: [0.05, 0.1, 0.25, 0.5, 1],

  DENOISE_STRENGTH: 0.2,
  DENOISE_STRENGTH_VALUES: [0.1, 0.2, 0.5],
};
